/**
 * MaterialSymbol is a component that renders a Material Symbol.
 * It is a wrapper around the Material Symbols Outlined font.
 * It is used to render icons in the platform.
 * Note that the Material Symbols Outlined font is not the same as the Material Icons font.
 * The Material Symbols Outlined font is a newer font that is more flexible and has more icons but doesn't
 * yet have react components.
 * @see https://fonts.google.com/icons?icon.style=Outlined
 *
 * @param name - The name of the icon to render. Musst be one of the Material Symbols.
 * @param size - The size of the icon. Min 20, Max 48.
 * @param color - The color of the icon.
 * @param className - The classes to add onto the icon
 * @returns A React component that renders a Material Symbol.
 */

const MaterialSymbol = ({
    name,
    size = 20,
    color = '#002d72',
    className = 'flex-shrink-0'
}: {
    name: string
    size?: number
    color?: string
    className?: string
}) => {
    return (
        <span
            className={`material-symbols-outlined ${className}`}
            style={{ color, fontVariationSettings: `'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' ${size}` }}
        >
            {name}
        </span>
    )
}

export default MaterialSymbol
